import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n';
import { StatTile } from '../../ui/DataBits';
import { TeacherFrame } from './TeacherFrame';
import { errorText, rpc, type AppError, type Calibration } from './api';

// I4: how the teacher's predictions compare with what classes said, over
// time and by context. Private to the teacher.
export function CalibrationPage() {
  const { t } = useI18n();
  return (
    <TeacherFrame title={t['ts.navCalibration']} active="calibration">
      {() => <CalibrationBody />}
    </TeacherFrame>
  );
}

function CalibrationBody() {
  const { t, num } = useI18n();
  const [data, setData] = useState<Calibration | null>(null);
  const [err, setErr] = useState<AppError | null>(null);
  useEffect(() => {
    rpc<Calibration>('teacher_calibration').then((r) => (r.error ? setErr(r.error) : setData(r.data)));
  }, []);

  if (err) return <p className="notice notice-block" role="alert">{errorText(t, err)}</p>;
  if (!data) return <p role="status">{t.loading}</p>;
  const gap = data.mean_gap;
  const rows = Object.entries(data.by_context);

  return (
    <>
      <div className="stat-row">
        <StatTile label={t['ts.calSessions']} value={data.sessions} sub={t['ts.calSessionsSub']} />
        <StatTile
          label={t['ts.calGap']}
          value={gap === null ? '–' : `${gap > 0 ? '+' : ''}${num(gap)}`}
          sub={gap === null ? t['ts.calNone'] : gap > 0.25 ? t['ts.calHigher'] : gap < -0.25 ? t['ts.calLower'] : t['ts.calClose']}
        />
      </div>
      <section className="panel p5" aria-labelledby="cal-ctx">
        <h2 className="panel-title" id="cal-ctx">{t['ts.calByContext']}</h2>
        {rows.length === 0 ? (
          <p className="text-muted">{t['ts.calEmpty']}</p>
        ) : (
          <dl className="kv">
            {rows.map(([k, v]) => (
              <div key={k}>
                <dt>{k === 'none' ? t['ts.tagNone'] : t[`ts.tag.${k}` as 'ts.tag.normal']}</dt>
                <dd>
                  {`${v.mean_gap > 0 ? '+' : ''}${num(v.mean_gap)}`} · {t['ts.calN'](v.n)}
                </dd>
              </div>
            ))}
          </dl>
        )}
        <p className="form-hint">{t['ts.calHow']}</p>
        <p className="form-hint">{t['ts.onlyYou']}</p>
      </section>
      <p><Link className="ts-link" to="/teacher">← {t['teacher.title']}</Link></p>
    </>
  );
}
